import React, { useContext, useEffect } from 'react';
import { Redirect, Route, useLocation } from 'react-router-dom';
import StoreContext from '../../Store/context';

// eslint-disable-next-line
const RouterLogin = ({ component: Component, children, ...rest }) => {
  const { credencials, setOpenModal } = useContext(StoreContext);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const hasLoginToken = Boolean(params.get('loginToken'));

  useEffect(() => {
    if (setOpenModal) {
      setOpenModal(false);
    }
  }, [setOpenModal]);

  useEffect(() => {
    if (!credencials && !hasLoginToken && location.pathname !== '/onboarding') {
      const companyHistory = localStorage.getItem('duzz_company_history');
      const recentPages = localStorage.getItem('recentPages');
      const pendingBusinessData = localStorage.getItem('pendingBusinessData');
      const onboardingSessionId = localStorage.getItem('onboarding_session_id');
      localStorage.clear();
      if (companyHistory) {
        localStorage.setItem('duzz_company_history', companyHistory);
      }
      if (recentPages) {
        localStorage.setItem('recentPages', recentPages);
      }
      if (pendingBusinessData) {
        localStorage.setItem('pendingBusinessData', pendingBusinessData);
      }
      if (onboardingSessionId) {
        localStorage.setItem('onboarding_session_id', onboardingSessionId);
      }
    }
  }, [credencials, hasLoginToken, location.pathname]);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (credencials && !hasLoginToken) {
          return <Redirect to="/home" />;
        }
        if (Component) {
          return <Component {...props} />;
        }
        return children;
      }}
    />
  );
};

export default RouterLogin;


